import React from 'react';
import Layout from '../../components/Layout/Layout';
import CompanyPage from '../../pages/CompanyPage/CompanyPage';
import styles from './CompanyPagePage.module.css';

const CompanyPagePage = () => {
  return (
    <Layout width="1440px">
      <div className={styles.companyPageStack}>
        <CompanyPage 
          companyId="ff271c2a-d2a7-426f-bbe1-599e98d870ba"
          size="Desktop 1440"
        />
      </div>
    </Layout>
  );
};

export default CompanyPagePage;